<template>
  <div class="driver-info new"
       :class="{'over-flow-hidden': overflowHidden}">
    <ucar-title type="confirmBack"
                text="尚未完成提交，是否退出报名"
                ok-text="确定退出"
                v-if="needLogout">{{title}}</ucar-title>
    <ucar-title to="/progress-info"
                v-else>{{title}}</ucar-title>
    <ucar-section class="info-city">
      <div class="row">
        <label>服务城市</label>
        <ucar-val :name="vuexCurrentCity.cityName"
                  :disabled="forbidenChooseServiceCity"
                  @click="showServiceCityChoose"></ucar-val>
      </div>
    </ucar-section>
    <div class="photo-info">
      <div class="photo-group-title">身份证</div>
      <div class="photo-group">
        <ucar-upload-img v-bind="photoBaseData.idCard"
                         v-model="photoInfo.idCardImgFaceUrl"
                         @uploadFinish="autoInputIdCard"
                         :error="photoError.idCardNo"></ucar-upload-img>
        <ucar-upload-img v-bind="photoBaseData.idCardBack"
                         v-model="photoInfo.idCardImgbackUrl"
                         @uploadFinish="autoInputIdCardBack"
                         :error="photoError.idCardBack"></ucar-upload-img>
      </div>
      <div class="photo-group-title">驾驶证</div>
      <div class="photo-group">
        <ucar-upload-img v-bind="photoBaseData.license"
                         v-model="photoInfo.driverLicenseImgUrl"
                         @uploadFinish="autoInputLicense"
                         :error="photoError.license"></ucar-upload-img>
        <ucar-upload-img v-bind="photoBaseData.secondLicense"
                         v-model="photoInfo.driverLicenseCopyImgUrl"
                         :error="photoError.secondLicense"></ucar-upload-img>
      </div>
      <template v-if="needNetworkLicense">
        <div class="photo-group-title">网约车驾驶员证</div>
        <div class="photo-group">
          <ucar-upload-img v-bind="photoBaseData.networkLicense"
                           v-model="photoInfo.onLineDriverLicenseUrl"
                           :error="photoError.networkLicense"></ucar-upload-img>
        </div>
      </template>
      <template v-if="vuexCurrentCity.needAcidDetection">
        <div class="photo-group-title">核酸检测证明</div>
        <div class="photo-group">
          <ucar-upload-img v-bind="photoBaseData.acidCheckLicense"
                           v-model="photoInfo.nucleicAcidDetectionImg"
                           :error="photoError.acidDetection"></ucar-upload-img>
        </div>
      </template>
    </div>
    <!-- <ucar-section title="已根据身份证自动识别您的信息" v-if="readIdentifyComplete">
      <div class="row little">
        <img src="../../assets/icon-name.png">
        <div class="value">{{info.name}}</div>
      </div>
      <div class="row little">
        <img src="../../assets/icon-idCard.png">
        <div class="value">{{info.idCardNo}}</div>
      </div>
    </ucar-section> -->
    <ucar-section title="已根据图片识别您的信息，如不正确请修改" v-if="ocrComplete">
      <div class="row row-info">
        <label>姓名</label>
        <dynamic-textarea placeholder="请输入"
                          :only-zh="true"
                          v-model="info.name"
                          ref="inp"
                          :maxlength="20"
                          :handleInput="changeName"></dynamic-textarea>
      </div>
      <div class="row row-info">
        <label>身份证号</label>
        <!-- <dynamic-textarea placeholder="请输入"
                          :forbid-zh="true"
                          v-model="info.idCardNo"
                          :maxlength="20"></dynamic-textarea> -->
        <number-x-keyboard v-model="info.idCardNo" :maxlength="20" placeholder="请输入"/>
      </div>
      <div class="row row-info">
        <label>身份证有效期至</label>
        <ucar-date-select v-model="info.validTo"
                          type="idCard"
                          :start-date="new Date()"
                          :end-date="new Date((new Date()).getFullYear() + 20, (new Date()).getMonth(), (new Date()).getDate())"></ucar-date-select>
      </div>
      <div class="row row-info">
        <label>准驾车型</label>
        <ucar-select :options="baseData.driverLicenseTypes"
                     placeholder="请选择"
                     v-model="info.driverLicenseClass"></ucar-select>
      </div>
      <div class="row row-info">
        <label>驾照初次领取日期</label>
        <ucar-date-select v-model="info.driverLicenseIssueDate"
                          :start-date="new Date(1970, (new Date()).getMonth(), (new Date()).getDate())"
                          :end-date="new Date((new Date()).getFullYear() - 3, (new Date()).getMonth(), (new Date()).getDate())"
                          from="end"
                          tips="请确保驾照领取时间超过3年"></ucar-date-select>
      </div>
      <div class="row row-info">
        <label>驾驶证有效期至</label>
        <ucar-date-select v-model="info.driverLicenseValidTo"
                          :start-date="new Date()"
                          :end-date="new Date((new Date()).getFullYear() + 20, (new Date()).getMonth(), (new Date()).getDate())"></ucar-date-select>
      </div>
    </ucar-section>
    <!-- <ucar-section title="以下为自动识别图片的结果，如不正确请修改"
                  v-if="rejectedCount >= 3">
      <div class="row">
        <label>身份证有效期至</label>
        <ucar-date-select v-model="info.validTo"
                          type="idCard"
                          :start-date="new Date()"
                          :end-date="new Date((new Date()).getFullYear() + 20, (new Date()).getMonth(), (new Date()).getDate())"></ucar-date-select>
      </div>
      <div class="row">
        <label>准驾车型</label>
        <ucar-select :options="baseData.driverLicenseTypes"
                     placeholder="请选择"
                     v-model="info.driverLicenseClass"></ucar-select>
      </div>
      <div class="row">
        <label>驾照初次领取日期</label>
        <ucar-date-select v-model="info.driverLicenseIssueDate"
                          :start-date="new Date(1970, (new Date()).getMonth(), (new Date()).getDate())"
                          :end-date="new Date((new Date()).getFullYear() - 3, (new Date()).getMonth(), (new Date()).getDate())"
                          from="end"
                          tips="请确保驾照领取时间超过3年"></ucar-date-select>
      </div>
      <div class="row">
        <label>驾驶证有效期至</label>
        <ucar-date-select v-model="info.driverLicenseValidTo"
                          :start-date="new Date()"
                          :end-date="new Date((new Date()).getFullYear() + 20, (new Date()).getMonth(), (new Date()).getDate())"></ucar-date-select>
      </div>
    </ucar-section> -->
    <ucar-section>
      <div class="row">
        <label>户籍城市</label>
        <ucar-city-select :options="baseData.houseHoldCityList"
                          placeholder="请选择"
                          @overflow-hidden="reLayout"
                          v-model="info.houseHoldCity"></ucar-city-select>
      </div>
      <div class="row">
        <label>驾驶证档案编号</label>
        <dynamic-textarea placeholder="请输入"
                          :forbid-zh="true"
                          v-model="info.driverLicenseFileNo"
                          :maxlength="20"></dynamic-textarea>
      </div>
      <div class="row"
           v-if="needNetworkLicense">
        <label class="lang">网约车驾驶员证证件号</label>
        <dynamic-textarea placeholder="请输入"
                          :forbid-zh="true"
                          v-model="info.onLineDriverLicenseNo"
                          :maxlength="20"></dynamic-textarea>
      </div>
      <div class="row">
        <label class="lang">从何处了解报名信息（选填）</label>
        <ucar-select :options="baseData.channelOptions"
                     placeholder="请选择"
                     v-model="info.sourceId"></ucar-select>
      </div>
    </ucar-section>
    <p class="driver-info-auth"
       v-if="enableSubmit">点击提交即表示同意<span @click="goAuthorizeProtocol">《个人征信查询授权书》</span></p>
    <div class="footer">
      <button type="button"
              class="btn-submit"
              :class="{'btn-submit-enable': enableSubmit}"
              @click="submit">
        提交
      </button>
    </div>
    <transition name="fade"
                mode="out-in">
      <city-choose v-if="showCityChoose"
                   @change="selectCity"
                   :list="cityOptions"
                   :value="vuexCurrentCity"></city-choose>
    </transition>
    <error-dialog v-if="showErrorDialog"
                  @close="closeErrorDialog"
                  :groups="rejectErrors"></error-dialog>
    <protocol-dialog v-if="showProtocolDialog"
                     @agree="sign"
                     @close="showProtocolDialog = false"></protocol-dialog>
  </div>
</template>

<script>
import CityChoose from '../../components/city-choose'
import ErrorDialog from '../../components/error-dialog'
import ProtocolDialog from '../../components/protocol-dialog'
import DynamicTextarea from '../../components/dynamic-textarea'
import valid from '../../utils/valid-check'
import preload from '../../utils/preload'
import { PhotoBaseData, resetIdCard, resetIdCardBack, resetDriverLicense, checkFailText } from '../../utils/constants'
import { transformCities, copyTargetProperty, compareTargetProperty } from '../../utils/transform'
import { getRecruitSources, getHouseHoldCities, validateDriverInfo, submitDriverInfo, readIdCard, readDriverLicense, sign } from '../../api'
import NumberXKeyboard from "../../components/number-x-keyboard"
export default {
  components: {
    CityChoose,
    ErrorDialog,
    ProtocolDialog,
    DynamicTextarea,
    NumberXKeyboard
  },
  data () {
    return {
      mode: 'normal',
      needLogout: true,
      rejectedCount: 0,
      showCityChoose: false,
      showErrorDialog: false,
      showProtocolDialog: false,
      forbidenChooseServiceCity: false, // 是否可以更改服务城市，如果当前申请单进入过人工审核状态则无法再次修改服务城市
      rejectErrors: [],
      // 身份证OCR缓存对象
      idCardOcrInfo: {
        ...resetIdCard,
        ...resetIdCardBack
      },
      // 驾驶证OCR缓存对象
      driverLicenseOcrInfo: {
        ...resetDriverLicense
      },
      info: {
        name: '',
        idCardNo: '',
        gender: '',
        idCardOcr: 1, // 后台需要，身份证OCR识别出的信息直接提交则为1，修改过则为0
        driverLicenseOcr: 1, // 后台需要，驾驶证OCR识别出的信息直接提交则为1，修改过则为0
        birthday: '',
        address: '',
        nation: '',
        issuingAuthority: '',
        validTo: '',
        validFrom: '',
        driverLicenseNo: '',
        driverLicenseName: '',
        driverLicenseAddress: '',
        driverLicenseBirthday: '',
        driverLicenseIssueDate: '', // 驾驶证初次申领时间
        driverLicenseClass: '', // 驾驶证准驾车型
        driverLicenseValidFrom: '', // 驾驶证有效期起始时间
        driverLicenseValidTo: '', // 驾驶证有效期截止时间
        houseHoldCity: {}, // 户籍城市
        onLineDriverLicenseNo: '', // 网约车驾驶员资格证号
        driverLicenseFileNo: '', // 驾驶证档案编号
        sourceId: '' // 招募来源Id
      },
      photoInfo: {
        idCardImgFaceUrl: '',
        idCardImgbackUrl: '',
        driverLicenseImgUrl: '',
        driverLicenseCopyImgUrl: '',
        onLineDriverLicenseUrl: '',
        nucleicAcidDetectionImg: '', // 核酸校验证明图片
      },
      photoError: {
        idCardNo: '',
        idCardBack: '',
        license: '',
        secondLicense: '',
        networkLicense: '',
        acidDetection: ''
      },
      photoBaseData: PhotoBaseData,
      baseData: {
        driverLicenseTypes: [
          {
            name: 'C2',
            value: 7
          },
          {
            name: 'C1',
            value: 6
          },
          {
            name: 'B2',
            value: 5
          },
          {
            name: 'B1',
            value: 4
          },
          {
            name: 'A3',
            value: 3
          },
          {
            name: 'A2',
            value: 2
          },
          {
            name: 'A1',
            value: 1
          },
          // {
          //   name: 'C3',
          //   value: 8
          // },
          // {
          //   name: 'C4',
          //   value: 9
          // },
          // {
          //   name: 'C5',
          //   value: 10
          // },
          // {
          //   name: 'D',
          //   value: 11
          // },
          // {
          //   name: 'E',
          //   value: 12
          // },
          // {
          //   name: 'F',
          //   value: 13
          // },
          // {
          //   name: 'M',
          //   value: 14
          // },
          // {
          //   name: 'N',
          //   value: 15
          // },
          // {
          //   name: 'p',
          //   value: 16
          // },
        ],
        houseHoldCityList: [],
        tempHouseHoldCityList: [],
        serviceCityList: [],
        channelOptions: []
      },
      overflowHidden: false,
      // 识别结果 区域 姓名输入框聚焦
      infoNameInpOnFoucs: false,
    }
  },
  computed: {
    cityOptions () {
      return transformCities(this.vuexServiceCities)
    },
    readIdentifyComplete () {
      return this.info.idCardNo && this.info.name
    },
    needNetworkLicense() {
      return this.vuexCompanyId ? this.vuexCurrentCity.needCompanyNetworkLicense : this.vuexCurrentCity.needNetworkLicense
    },
    enableSubmit () {
      const errorInfo = valid.notEmpty(this.photoInfo.idCardImgFaceUrl, '身份证正面') ||
        valid.notEmpty(this.photoInfo.idCardImgbackUrl, '身份证国徽面') ||
        valid.notEmpty(this.photoInfo.driverLicenseImgUrl, '驾驶证正本') ||
        valid.notEmpty(this.photoInfo.driverLicenseCopyImgUrl, '驾驶证副本') ||
        valid.notEmpty(this.info.driverLicenseClass, '准驾车型') ||
        (this.needNetworkLicense &&
          valid.notEmpty(this.photoInfo.onLineDriverLicenseUrl, '网约车驾驶员证')) ||
        (this.needNetworkLicense &&
          valid.notEmpty(this.info.onLineDriverLicenseNo, '网约车驾驶员证证件号')) ||
        (this.vuexCurrentCity.needAcidDetection &&
          valid.notEmpty(this.photoInfo.nucleicAcidDetectionImg, '核酸检测证明')) ||
        valid.notEmpty(this.info.name, '真实姓名') ||
        valid.notEmpty(this.info.idCardNo, '身份证号') ||
        valid.notEmpty(this.info.validTo, '身份证有效日期') ||
        valid.notEmpty(this.info.driverLicenseValidTo, '驾驶证有效日期') ||
        valid.notEmpty(this.info.houseHoldCity, '户籍城市') ||
        valid.notEmpty(this.info.driverLicenseIssueDate, '驾照初次领取日期') ||
        valid.notEmpty(this.info.driverLicenseFileNo, '驾驶证档案编号')
      return errorInfo === ''
    },
    ocrComplete(){
      return (this.info.name || this.info.idCardNo) && (this.info.driverLicenseName || this.info.driverLicenseNo ) && this.info.validTo
    }
  },
  watch: {
    'info.driverLicenseFileNo' (val) {
      this.info.driverLicenseFileNo = val.replace(/[^A-Za-z\d]/g, '').toUpperCase()
    },
    'info.onLineDriverLicenseNo' (val) {
      this.info.onLineDriverLicenseNo = val.replace(/[^A-Za-z\d]/g, '').toUpperCase()
    }
  },
  methods: {
    reLayout (val) {
      this.overflowHidden = val
      if (!this.overflowHidden) {
        setTimeout(() => {
          document.documentElement.scroll(0, 2000)
          document.body.scroll(0, 2000)
        })
      }
    },
    showServiceCityChoose () {
      if (!this.forbidenChooseServiceCity) this.showCityChoose = true
    },
    selectCity (val) {
      this.showCityChoose = false
      if (val) this.setVuexCurrentCity(val)
    },
    getBaseData () {
      this.$loading.show()
      preload([
        PhotoBaseData.idCard.defaultImg,
        PhotoBaseData.idCardBack.defaultImg,
        PhotoBaseData.license.defaultImg,
        PhotoBaseData.secondLicense.defaultImg,
        PhotoBaseData.networkLicense.defaultImg,
        PhotoBaseData.acidCheckLicense.defaultImg
      ]).then(() => {
        return Promise.all([
          getRecruitSources(),
          getHouseHoldCities()
        ])
      }).then(res => {
        this.baseData.channelOptions = res[0].recruitSourceList.map(item => {
          return {
            name: item.recruitSource,
            value: item.recruitSourceId
          }
        })
        this.baseData.tempHouseHoldCityList = res[1].houseHoldCityList
        this.baseData.houseHoldCityList = transformCities(
          res[1].houseHoldCityList
          , false)
        if (this.vuexDriverInfo) {
          copyTargetProperty(this.info, this.vuexDriverInfo)
          this.ocrResultMessageAlert()
          copyTargetProperty(this.photoInfo, this.vuexDriverInfo)
          // 如果是从缓存中读取，需要对当前缓存中的信息做判断如果上次提交的OCR识别结果为完成，则需将当前缓存的提交信息反向映射为OCR身份证/驾驶证缓存信息，以便在提交时完成对比
          if (this.vuexDriverInfo.idCardOcr === 1) copyTargetProperty(this.idCardOcrInfo, this.info)
          if (this.vuexDriverInfo.driverLicenseOcr === 1) copyTargetProperty(this.driverLicenseOcrInfo, this.info)
          this.rejectedCount = this.vuexDriverInfo.driverRejectedCount
          this.forbidenChooseServiceCity = this.vuexDriverInfo.vehicleBindable === 1 // 如果次申请单可以绑定车辆，即代表次申请单进入过人工审核状态
          if (this.vuexDriverInfo.serviceCityId) {
            const currentCity = this.vuexServiceCities.find(item => item.cityId === this.vuexDriverInfo.serviceCityId)
            this.setVuexCurrentCity({ ...currentCity, id: this.vuexDriverInfo.serviceCityId })
          }
        }
        this.$loading.hidden()
      })
    },
    async sign () {
      this.showProtocolDialog = false
      const res = await sign({
        recruitId: this.vuexRecruitId
      })
      if (res.resultCode === 0) {
        this.$router.push('/video-info')
      }
    },
    async autoInputIdCard (val) {
      this.$loading.show('正在识别图片信息')
      try {
        this.trackEvent('司招-身份证正面上传', 'success')
        const res = await readIdCard({
          recruitId: this.vuexRecruitId,
          idCardImgFaceUrl: val
        })
        console.log('readIdCard',res)
        this.$loading.hidden()
        const body = {}
        for (const k in res) {
          if (res[k]) body[k] = res[k]
        }
        this.info = { ...this.info, ...body, gender: body.gender === '男' ? 1 : 0 }
        this.ocrResultMessageAlert()
        // 缓存识别成功的身份证正面OCR信息
        copyTargetProperty(this.idCardOcrInfo, this.info)
        this.$alert({
          type: 'success',
          content: '识别图片成功'
        })
        // 去除OCR识别错误提示
        this.photoError.idCardNo = ''
      } catch (error) {
        // 识别失败，重置身份证个人信息面信息
        this.info = { ...this.info, ...resetIdCard }
        this.ocrResultMessageAlert()
        // 重置缓存中的身份证正面OCR信息
        copyTargetProperty(this.idCardOcrInfo, { ...resetIdCard })
        this.photoError.idCardNo = '未识别到姓名或身份证号，请重新上传'
        this.trackEvent('司招-身份证正面识别失败', 'error')
      }
    },
    async autoInputIdCardBack (val) {
      this.$loading.show('正在识别图片信息')
      try {
        this.trackEvent('司招-身份证反面上传', 'success')
        const res = await readIdCard({
          recruitId: this.vuexRecruitId,
          idCardImgBackUrl: val
        })
        this.$loading.hidden()
        const body = {}
        for (const k in res) {
          if (res[k]) body[k] = res[k]
        }
        this.$alert({
          type: 'success',
          content: '识别图片成功'
        })
        this.info = { ...this.info, ...body }
        this.ocrResultMessageAlert()
        // 缓存识别成功的身份证国徽面OCR信息
        copyTargetProperty(this.idCardOcrInfo, this.info)
        // 去除OCR识别错误提示
        this.photoError.idCardBack = ''
      } catch (err) {
        // 识别失败，重置身份证国徽面信息
        this.info = { ...this.info, ...resetIdCardBack }
        this.ocrResultMessageAlert()
        // 重置缓存中的身份证国徽面OCR信息
        copyTargetProperty(this.idCardOcrInfo, { ...resetIdCardBack })
        this.ocrResultMessageAlert()
        this.photoError.idCardBack = '未识别到身份证国徽面信息，请重新上传'
        this.trackEvent('司招-身份证反面识别失败', 'error')
      }
    },
    async autoInputLicense (val) {
      this.$loading.show('正在识别图片信息')
      try {
        this.trackEvent('司招-驾照正面上传', 'success')
        const res = await readDriverLicense({
          recruitId: this.vuexRecruitId,
          drivingLicenseImgUrl: val
        })
        this.$loading.hidden()
        this.info = { ...this.info, ...res }
        this.ocrResultMessageAlert()
        // 缓存识别成功的驾驶证OCR信息
        copyTargetProperty(this.driverLicenseOcrInfo, this.info)
        this.$alert({
          type: 'success',
          content: '识别图片成功'
        })
        // 去除OCR识别错误提示
        this.photoError.license = ''
      } catch (error) {
        // 识别失败，重置驾驶证信息
        this.info = { ...this.info, ...resetDriverLicense }
        this.ocrResultMessageAlert()
        // 重置缓存中的驾驶证OCR信息
        copyTargetProperty(this.driverLicenseOcrInfo, { ...resetIdCardBack })
        this.photoError.license = '未识别到驾驶证正面信息，请重新上传'
        this.trackEvent('司招-驾照正面识别失败', 'error')
      }
    },
    arrange () {
      const body = {
        // 由于原司机信息缓存对象中含有驳回次数以及是否进入过人工审核字段，所以对象中的这些原有字段需要保留
        ...this.vuexDriverInfo,
        ...this.info,
        ...this.photoInfo,
        driverLicenseNo: this.info.driverLicenseNo,
        recruitId: this.vuexRecruitId,
        serviceCityId: this.vuexCurrentCity.cityId,
        mobile: this.vuexPersonMobile,
        houseHoldCity: this.info.houseHoldCity.name
      }

      // 如果身份证相关信息与缓存中的身份证OCR信息不符则证明用户手动修改过身份证相关信息
      body.idCardOcr = compareTargetProperty(this.idCardOcrInfo, this.info) ? 1 : 0
      // 如果驾驶证相关信息与缓存中的驾驶证OCR信息不符则证明用户手动修改过驾驶证相关信息
      body.driverLicenseOcr = compareTargetProperty(this.driverLicenseOcrInfo, this.info) ? 1 : 0
      // 缓存当前待提交的信息
      this.setVuexDriverInfo(body)
      return body
    },
    async submit () {
      try {
        // 从身份证里获取性别 出生年月
        this.info.gender = this.info.idCardNo.substring(16,17) % 2
        let birth = this.info.idCardNo.substring(6,14)
        this.info.birthday = birth.substring(0,4) + '-' + birth.substring(4,6) + '-' + birth.substring(6,8)
        const body = this.arrange()
        this.trackEvent('司招-申请表单人-提交', 'click')
        // 验证司机信息
        if (!this.needNetworkLicense) { // 网约
          body.onLineDriverLicenseUrl = ''
          body.onLineDriverLicenseNo = ''
        }
        if (!this.vuexCurrentCity.needAcidDetection) { // 核酸
          body.nucleicAcidDetectionImg = ''
        }
        console.log(body)
        await validateDriverInfo(body)
        // 提交司机信息
        const submitRes = await submitDriverInfo(body)
        if (submitRes.checkDriverResult !== 0) {
          const offLine = submitRes.checkDriverResult === -2
          this.$alert({
            type: 'confirm',
            dsc: `该身份证号${offLine ? checkFailText.offLine : checkFailText.settledBySubmit}`,
            okText: offLine ? '我知道了' : '我知道了，下载App',
            center: true,
            callback: () => {
              if (!offLine) {
                location.assign('https://m.10101111.com/ptdapp/d')
              }
            }
          })
          return
        }
        if (submitRes.checkResult === 1) {
          this.showProtocolDialog = true
          return
        }
        // 处理驳回错误信息
        if (submitRes.checkResult === 2) {
          this.rejectedCount = submitRes.rejectedCount
          if (submitRes.idCardCheckList.length > 0) {
            const group = {
              title: '身份证',
              type: 'list',
              list: []
            }
            const list = submitRes.idCardCheckList
            list.forEach(item => {
              group.list.push(item)
            })
            this.rejectErrors.push(group)
          }
          if (submitRes.drivingLicenseCheckList.length > 0) {
            const group = {
              title: '驾驶证',
              type: 'list',
              list: []
            }
            const list = submitRes.drivingLicenseCheckList
            list.forEach(item => {
              group.list.push(item)
            })
            this.rejectErrors.push(group)
          }
          if (submitRes.otherCheckList.length > 0) {
            const group = {
              title: '其他',
              type: 'text',
              content: ''
            }
            const list = submitRes.otherCheckList
            list.forEach(item => {
              group.content += `${item.field}:${item.desc};`
            })
            this.rejectErrors.push(group)
          }
          this.showErrorDialog = true
          return
        }
        if (submitRes.checkResult === 3) {
          this.changeStatusToReviewInfo()
          this.$router.push(`/progress-info?id=${this.vuexRecruitId}`)
        }
      } catch (error) {
        // 报错的时候更新一下城市配置
        this.$store.dispatch('setVuexCurrentCity', { id: this.vuexCurrentCity.cityId })
        console.warn(error)
      }
    },
    closeErrorDialog () {
      this.showErrorDialog = false
      this.rejectErrors = []
    },
    goAuthorizeProtocol () {
      this.arrange()
      this.$router.push('/authorize-protocol')
    },
    changeOcrResult () {
      this.infoNameInpOnFoucs = true
      this.$nextTick(() => {
        this.$refs['inp'].$refs["textarea"].focus()
      })
    },
    ocrResultMessageAlert(){
      // 判断识别结果是否有误
      let resultMessageArr = []
      let flag = true
      if(this.info.name !== this.info.driverLicenseName && this.info.name && this.info.driverLicenseName){
        // 姓名不一致
        resultMessageArr.push(`驾驶证姓名与身份证不一致`)
        flag = false
      }

      if(this.info.driverLicenseNo !== this.info.idCardNo && this.info.driverLicenseNo && this.info.idCardNo){
        // 证件号不一致
        resultMessageArr.push(`驾驶证号与身份证号不一致`)
        flag = false
      }
      if(!flag){
        resultMessageArr.push('请确认证件照片正确无误，若识别信息不正确请修改。')
        this.$alert({
          type:'confirm',
          showCancel:false,
          okText:'我知道了',
          content:'图片识别结果',
          list:[...resultMessageArr]
        })
      }

    },
    changeName(val){
      // 需不需同步驾驶证名字
      // console.log(val)
      // this.info.driverLicenseName = val
    }
  },
  mounted () {
    if (this.$route.query.redirectTo === 'progress-info') {
      this.needLogout = false
    }
    this.getBaseData()
    // this.sign()
  }
}
</script>

<style scoped>
>>> .ocr-info-title .ucar-section-title {
  font-weight: 550;
}
</style>
